'use strict';

/*global services*/
/*global WinsModal*/
/*global isEmpty*/
function WinsConfirm(id) {
  WinsModal.call(this, id);

  this.init();
}

WinsConfirm.prototype = $.extend({}, WinsModal.prototype, {
  constructor: 'WinsConfirm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    var confirmHandler = function () {
      if (!isEmpty(_this.setting.confirmCallback)) {
        if ($.isFunction(_this.setting.confirmCallback)) {
          _this.setting.confirmCallback();
        } else {
          window[_this.setting.confirmCallback]();
        }
      }

      return false;
    };

    var rejectHandler = function () {
      if (!isEmpty(_this.setting.rejectCallback)) {
        if ($.isFunction(_this.setting.rejectCallback)) {
          _this.setting.rejectCallback();
        } else {
          window[_this.setting.rejectCallback]();
        }
      } else {
        _this.close();
      }

      return false;
    };

    _this.$modal.find('.modal-footer .submit.btn-confirm').bind('click', confirmHandler);
    _this.$modal.find('.modal-footer .submit.btn-reject').bind('click', rejectHandler);
  },

  setModalForm: function setModalForm() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit.btn-confirm').html(_this.setting.confirmBtnTitle);
    _this.$modal.find('.modal-footer .submit.btn-reject').html(_this.setting.rejectBtnTitle);
        
    _this.$modal.find('.modal-footer .submit.btn-confirm').removeClass('btn-primary').addClass(_this.setting.confirmBtnClass);
    _this.$modal.find('.modal-footer .submit.btn-reject').removeClass('btn-danger').addClass(_this.setting.rejectBtnClass);
    
    _this.$modal.find('.modal-footer .modal-buttons').hide();
    _this.$modal.find('.modal-footer .modal-buttons-' + _this.setting.buttonsSize).show();
    if (_this.setting.rejectBtnVisible === false) {
      _this.$modal.find('.modal-footer .btn-reject').remove();
    }
  },

  defineWinsConfirmSetting: function defineWinsModalSetting() {
    var _this = this;

    _this.defineWinsModalSetting();

    _this.defaultSetting = $.extend({}, _this.defaultSetting, {
      title: services.get('translator').trans('Title'),
      confirmBtnTitle: services.get('translator').trans('Confirm'),
      rejectBtnTitle: services.get('translator').trans('Reject'),
      confirmBtnClass: 'btn-primary',
      rejectBtnClass: 'btn-danger',
      rejectBtnVisible: true,
      buttonsSize: 'auto',
      keyboardClose: false,
      width: 'sm',
      height: 'auto',
      confirmCallback: null,
      rejectCallback: null
    });

  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.defineWinsConfirmSetting();

    var modalStr = '';
    modalStr += '<div class="modal fade ' + _this.defaultSetting.modalClass + '" tabindex="-1" role="dialog" id="' + _this.id + '" data-modal_class="' + _this.defaultSetting.modalClass + '">';
    modalStr +=   '<div class="modal-dialog" role="document">';
    modalStr +=     '<div class="modal-content">';
    modalStr +=       '<div class="modal-header">';
    modalStr +=         '<h4 class="modal-title">' + _this.defaultSetting.title + '</h4>';
    modalStr +=       '</div>';
    modalStr +=       '<div class="modal-body">' + _this.defaultSetting.content + '</div>';
    modalStr +=       '<div class="modal-footer">';
    modalStr +=         '<div class="row modal-buttons modal-buttons-lg">';
    modalStr +=           '<div class="col-xs-6">';
    modalStr +=             '<button type="button" class="btn btn-reject ' + _this.defaultSetting.rejectBtnClass + ' submit full-width">' + _this.defaultSetting.rejectBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=           '<div class="col-xs-6">';
    modalStr +=             '<button type="button" class="btn btn-confirm ' + _this.defaultSetting.confirmBtnClass + ' submit full-width">' + _this.defaultSetting.confirmBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=         '</div>';
    modalStr +=         '<div class="modal-buttons modal-buttons-auto">';
    modalStr +=           '<button type="button" class="btn btn-reject ' + _this.defaultSetting.rejectBtnClass + ' submit">' + _this.defaultSetting.rejectBtnTitle + '</button>';       
    modalStr +=           '<button type="button" class="btn btn-confirm ' + _this.defaultSetting.confirmBtnClass + ' submit">' + _this.defaultSetting.confirmBtnTitle + '</button>';
    modalStr +=         '</div>';
    modalStr +=       '</div>';
    modalStr +=     '</div>';
    modalStr +=   '</div>';
    modalStr += '</div>';

    _this.$modal = $(modalStr);

    $('body').append(_this.$modal);

    _this.registerCallbacks();
  }
});
